import RequestState from 'Enums/RequestState'
import IFFilterType from 'Enums/IFFilterType'

export const INITIAL_STATE = {
  countries: [],
  fetchCountriesRequestState: RequestState.UNINITIALIZED,
  fetchCountriesListCountRequestState: RequestState.UNINITIALIZED,
  countriesCount: 0,
  countriesPaginationOffset: 0,
  countriesFilters: [
    {
      type: IFFilterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
  ],
  addCountryRequestState: RequestState.UNINITIALIZED,
}
